import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito mucho dinero para empezar?',
    a: 'No, puedes empezar con tan solo $20 comprando artículos individuales en "Bin Stores".'
  }, {
    q: '¿Tengo que hablar inglés perfecto?',
    a: 'No, el sistema de mensajes de Facebook te permite usar traductor y nuestros guiones ya están listos.'
  }, {
    q: '¿Es seguro vender en Facebook?',
    a: 'Sí, en la guía te enseñamos los protocolos de seguridad y puntos de encuentro ideales.'
  }, {
    q: '¿Necesito un almacén o bodega?',
    a: 'No, puedes empezar desde una esquina de tu sala o tu garage.'
  }, {
    q: '¿Cómo sé si la mercancía sirve?',
    a: 'El checklist de inspección incluido te enseña a probar los artículos rápidamente.'
  }, {
    q: '¿Amazon sabe que estoy haciendo esto?',
    a: 'Sí, las tiendas de liquidación existen precisamente para que personas como tú muevan ese inventario.'
  }];
  return <section className="w-full bg-slate-900 py-16 md:py-24" data-id="element-23">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-25">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-27" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-700 rounded-lg bg-slate-800 overflow-hidden" data-id="element-28">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-29">
        <span className="text-lg font-semibold text-slate-200" data-id="element-30">{question}</span>
        <ChevronDown className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-31" />
      </button>

      <AnimatePresence data-id="element-32">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-33">
            <div className="p-6 pt-0 text-slate-400 border-t border-slate-700/50" data-id="element-34">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}